import React, { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Loader from "./Loader";
import UserContext from "../context/UserContext";

function GetBooks() {
  const { products, setProducts } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!products) {
      setLoading(true)
      fetch(`${process.env.REACT_APP_API_URL}/product/get`)
        .then((res) => res.json())
        .then((data) => setProducts(data))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    }
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <Outlet />
    </>
  );
}

export default GetBooks;
